import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import { HTTP } from "@/api/http-common";
import {
  getValueFromStorageByKey,
  setValueToStorageByKey,
} from "@/utils/localStorage";
import { hasPermissionUser } from "@/utils/permissionUtils";

import {
  MENU_ROUTE_NAME,
  PERMISSION_NAME,
  ROUTE_NAME,
} from "@/constants/constants";

const TrangChu = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/TrangChu"], () => {
    resolve(require("@/views/TrangChu"));
  });
};

const Trang401 = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/errors/401"], () => {
    resolve(require("@/views/errors/401"));
  });
};

const Trang403 = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/errors/403"], () => {
    resolve(require("@/views/errors/403"));
  });
};

const Trang404 = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/errors/404"], () => {
    resolve(require("@/views/errors/404"));
  });
};

const Trang500 = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/errors/500"], () => {
    resolve(require("@/views/errors/500"));
  });
};

const TrangDangNhap = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/TrangDangNhap"], () => {
    resolve(require("@/views/TrangDangNhap"));
  });
};

const TrangRouter = (resolve) => {
  require.ensure(["@/views/TrangRouter"], () => {
    resolve(require("@/views/TrangRouter"));
  });
};

const TrangDanhSachHoSoCanBo = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(
    ["@/views/quan-ly-danh-muc/ho-so-can-bo/TrangDanhSachHoSoCanBo"],
    () => {
      resolve(
        require("@/views/quan-ly-danh-muc/ho-so-can-bo/TrangDanhSachHoSoCanBo")
      );
    }
  );
};

const TrangTaoHoSoCanBo = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(
    ["@/views/quan-ly-danh-muc/ho-so-can-bo/TrangTaoHoSoCanBo"],
    () => {
      resolve(
        require("@/views/quan-ly-danh-muc/ho-so-can-bo/TrangTaoHoSoCanBo")
      );
    }
  );
};

const TrangSuaHoSoCanBo = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(
    ["@/views/quan-ly-danh-muc/ho-so-can-bo/TrangSuaHoSoCanBo"],
    () => {
      resolve(
        require("@/views/quan-ly-danh-muc/ho-so-can-bo/TrangSuaHoSoCanBo")
      );
    }
  );
};

const TrangXemHoSoCanBo = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(
    ["@/views/quan-ly-danh-muc/ho-so-can-bo/TrangXemHoSoCanBo"],
    () => {
      resolve(
        require("@/views/quan-ly-danh-muc/ho-so-can-bo/TrangXemHoSoCanBo")
      );
    }
  );
};

const TrangXemHoSoCanBoThuocDonVi = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(
    ["@/views/quan-ly-danh-muc/ho-so-can-bo/TrangXemHoSoCanBoThuocDonVi"],
    () => {
      resolve(
        require("@/views/quan-ly-danh-muc/ho-so-can-bo/TrangXemHoSoCanBoThuocDonVi")
      );
    }
  );
};

const TrangDanhSachDonVi = (resolve) => {
  require.ensure(["@/views/quan-ly-danh-muc/don-vi/TrangDanhSachDonVi"], () => {
    resolve(require("@/views/quan-ly-danh-muc/don-vi/TrangDanhSachDonVi"));
  });
};

const TrangTaoDonVi = (resolve) => {
  require.ensure(["@/views/quan-ly-danh-muc/don-vi/TrangTaoDonVi"], () => {
    resolve(require("@/views/quan-ly-danh-muc/don-vi/TrangTaoDonVi"));
  });
};

const TrangSuaDonVi = (resolve) => {
  require.ensure(["@/views/quan-ly-danh-muc/don-vi/TrangSuaDonVi"], () => {
    resolve(require("@/views/quan-ly-danh-muc/don-vi/TrangSuaDonVi"));
  });
};
const TrangXemDonVi = (resolve) => {
  require.ensure(["@/views/quan-ly-danh-muc/don-vi/TrangXemDonVi"], () => {
    resolve(require("@/views/quan-ly-danh-muc/don-vi/TrangXemDonVi"));
  });
};
const TrangDanhSachTinhThanhPho = (resolve) => {
  require.ensure(
    ["@/views/quan-ly-danh-muc/tinh-thanh/TrangDanhSachTinhThanhPho"],
    () => {
      resolve(
        require("@/views/quan-ly-danh-muc/tinh-thanh/TrangDanhSachTinhThanhPho")
      );
    }
  );
};
// const TrangDanhSachThongBao = resolve => {
//   require.ensure(["@/views/quan-ly-danh-muc/thong-bao-tuy-chinh/TrangDanhSachThongBao"], () => {
//     resolve(require("@/views/quan-ly-danh-muc/thong-bao-tuy-chinh/TrangDanhSachThongBao"));
//   });
// };

const TrangDanhSachChucVu = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/chuc-vu/TrangDanhSachChucVu"],
    () => {
      resolve(require("@/views/quan-tri-he-thong/chuc-vu/TrangDanhSachChucVu"));
    }
  );
};

const TrangTaoChucVu = (resolve) => {
  require.ensure(["@/views/quan-tri-he-thong/chuc-vu/TrangTaoChucVu"], () => {
    resolve(require("@/views/quan-tri-he-thong/chuc-vu/TrangTaoChucVu"));
  });
};

const TrangSuaChucVu = (resolve) => {
  require.ensure(["@/views/quan-tri-he-thong/chuc-vu/TrangSuaChucVu"], () => {
    resolve(require("@/views/quan-tri-he-thong/chuc-vu/TrangSuaChucVu"));
  });
};

const TrangXemChucVu = (resolve) => {
  require.ensure(["@/views/quan-tri-he-thong/chuc-vu/TrangXemChucVu"], () => {
    resolve(require("@/views/quan-tri-he-thong/chuc-vu/TrangXemChucVu"));
  });
};

const TrangDanhSachNhomChucVu = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/nhom-chuc-vu/TrangDanhSachNhomChucVu"],
    () => {
      resolve(
        require("@/views/quan-tri-he-thong/nhom-chuc-vu/TrangDanhSachNhomChucVu")
      );
    }
  );
};

const TrangDanhSachCapDonVi = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/cap-don-vi/TrangDanhSachCapDonVi"],
    () => {
      resolve(
        require("@/views/quan-tri-he-thong/cap-don-vi/TrangDanhSachCapDonVi")
      );
    }
  );
};

const TrangTaoNhomChucVu = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/nhom-chuc-vu/TrangTaoNhomChucVu"],
    () => {
      resolve(
        require("@/views/quan-tri-he-thong/nhom-chuc-vu/TrangTaoNhomChucVu")
      );
    }
  );
};

const TrangSuaNhomChucVu = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/nhom-chuc-vu/TrangSuaNhomChucVu"],
    () => {
      resolve(
        require("@/views/quan-tri-he-thong/nhom-chuc-vu/TrangSuaNhomChucVu")
      );
    }
  );
};

const TrangXemNhomChucVu = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/nhom-chuc-vu/TrangXemNhomChucVu"],
    () => {
      resolve(
        require("@/views/quan-tri-he-thong/nhom-chuc-vu/TrangXemNhomChucVu")
      );
    }
  );
};

const TrangTaoCapDonVi = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/cap-don-vi/TrangTaoCapDonVi"],
    () => {
      resolve(require("@/views/quan-tri-he-thong/cap-don-vi/TrangTaoCapDonVi"));
    }
  );
};

const TrangSuaCapDonVi = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/cap-don-vi/TrangSuaCapDonVi"],
    () => {
      resolve(require("@/views/quan-tri-he-thong/cap-don-vi/TrangSuaCapDonVi"));
    }
  );
};

const TrangXemCapDonVi = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/cap-don-vi/TrangXemCapDonVi"],
    () => {
      resolve(require("@/views/quan-tri-he-thong/cap-don-vi/TrangXemCapDonVi"));
    }
  );
};

const TrangTaoDanhMucHeThong = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/dm-he-thong/TrangTaoDanhMucHeThong"],
    () => {
      resolve(
        require("@/views/quan-tri-he-thong/dm-he-thong/TrangTaoDanhMucHeThong")
      );
    }
  );
};

const TrangSuaDanhMucHeThong = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/dm-he-thong/TrangSuaDanhMucHeThong"],
    () => {
      resolve(
        require("@/views/quan-tri-he-thong/dm-he-thong/TrangSuaDanhMucHeThong")
      );
    }
  );
};

const TrangXemDanhMucHeThong = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/dm-he-thong/TrangXemDanhMucHeThong"],
    () => {
      resolve(
        require("@/views/quan-tri-he-thong/dm-he-thong/TrangXemDanhMucHeThong")
      );
    }
  );
};

const TrangTaoDanhMucMenuHeThong = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/dm-menu-he-thong/TrangTaoDanhMucMenuHeThong"],
    () => {
      resolve(
        require("@/views/quan-tri-he-thong/dm-menu-he-thong/TrangTaoDanhMucMenuHeThong")
      );
    }
  );
};

const TrangSuaDanhMucMenuHeThong = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/dm-menu-he-thong/TrangSuaDanhMucMenuHeThong"],
    () => {
      resolve(
        require("@/views/quan-tri-he-thong/dm-menu-he-thong/TrangSuaDanhMucMenuHeThong")
      );
    }
  );
};

const TrangXemDanhMucMenuHeThong = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/dm-menu-he-thong/TrangXemDanhMucMenuHeThong"],
    () => {
      resolve(
        require("@/views/quan-tri-he-thong/dm-menu-he-thong/TrangXemDanhMucMenuHeThong")
      );
    }
  );
};

const TrangDanhSachVaiTro = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/vai-tro/TrangDanhSachVaiTro"],
    () => {
      resolve(require("@/views/quan-tri-he-thong/vai-tro/TrangDanhSachVaiTro"));
    }
  );
};

const TrangCapNhatVaiTro = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/vai-tro/TrangCapNhatVaiTro"],
    () => {
      resolve(require("@/views/quan-tri-he-thong/vai-tro/TrangCapNhatVaiTro"));
    }
  );
};

const TrangXemVaiTro = (resolve) => {
  require.ensure(["@/views/quan-tri-he-thong/vai-tro/TrangXemVaiTro"], () => {
    resolve(require("@/views/quan-tri-he-thong/vai-tro/TrangXemVaiTro"));
  });
};

const TrangCapNhatNguoiDung = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(
    ["@/views/quan-tri-he-thong/nguoi-dung/TrangCapNhatNguoiDung"],
    () => {
      resolve(
        require("@/views/quan-tri-he-thong/nguoi-dung/TrangCapNhatNguoiDung")
      );
    }
  );
};

const TrangXemNguoiDung = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/nguoi-dung/TrangXemNguoiDung"],
    () => {
      resolve(
        require("@/views/quan-tri-he-thong/nguoi-dung/TrangXemNguoiDung")
      );
    }
  );
};

const TrangQuanLyNguoiDung = (resolve) => {
  require.ensure(
    ["@/views/quan-tri-he-thong/nguoi-dung/TrangQuanLyNguoiDung"],
    () => {
      resolve(
        require("@/views/quan-tri-he-thong/nguoi-dung/TrangQuanLyNguoiDung")
      );
    }
  );
};

const TrangQuanLyThongTinNguoiDung = (resolve) => {
  require.ensure(
    [
      "@/views/quan-tri-he-thong/thong-tin-nguoi-dung/TrangQuanLyThongTinNguoiDung",
    ],
    () => {
      resolve(
        require("@/views/quan-tri-he-thong/thong-tin-nguoi-dung/TrangQuanLyThongTinNguoiDung")
      );
    }
  );
};

// const TrangQuanTriThongBao = resolve => {
//   // require.ensure is Webpack's special syntax for a code-split point.
//   require.ensure(["@/views/quan-tri-he-thong/TrangQuanTriThongBao"], () => {
//     resolve(require("@/views/quan-tri-he-thong/TrangQuanTriThongBao"));
//   });
// };

const TrangDanhSachApp = (resolve) => {
  require.ensure(["@/views/quan-tri-he-thong/app/TrangDanhSachApp"], () => {
    resolve(require("@/views/quan-tri-he-thong/app/TrangDanhSachApp"));
  });
};

const TrangDanhSachGroup = (resolve) => {
  require.ensure(["@/views/quan-tri-he-thong/group/TrangDanhSachGroup"], () => {
    resolve(require("@/views/quan-tri-he-thong/group/TrangDanhSachGroup"));
  });
};

const TrangDanhSachQuyen = (resolve) => {
  require.ensure(["@/views/quan-tri-he-thong/quyen/TrangDanhSachQuyen"], () => {
    resolve(require("@/views/quan-tri-he-thong/quyen/TrangDanhSachQuyen"));
  });
};

const TrangDanhSachLog = (resolve) => {
  require.ensure(["@/views/quan-tri-he-thong/log/TrangDanhSachLog"], () => {
    resolve(require("@/views/quan-tri-he-thong/log/TrangDanhSachLog"));
  });
};

const TrangXemGroup = (resolve) => {
  require.ensure(["@/views/quan-tri-he-thong/group/TrangXemGroup"], () => {
    resolve(require("@/views/quan-tri-he-thong/group/TrangXemGroup"));
  });
};

const TrangCapNhatGroup = (resolve) => {
  require.ensure(["@/views//quan-tri-he-thong/group/TrangCapNhatGroup"], () => {
    resolve(require("@/views/quan-tri-he-thong/group/TrangCapNhatGroup"));
  });
};

const TrangImport = (resolve) => {
  require.ensure(["@/views/quan-tri-he-thong/import/TrangImport"], () => {
    resolve(require("@/views/quan-tri-he-thong/import/TrangImport"));
  });
};

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: {
        name: ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.NAME,
      },
    },
    {
      path: ROUTE_NAME.TRANG_CHU,
      name: ROUTE_NAME.TRANG_CHU,
      menuName: MENU_ROUTE_NAME.TRANG_CHU,
      component: TrangChu,
      icon: "house-door",
      isShowLeftMenu: true,
    },
    {
      path: ROUTE_NAME._401,
      component: Trang401,
      isShowLeftMenu: false,
      expand: false,
    },
    {
      path: ROUTE_NAME._403,
      component: Trang403,
      isShowLeftMenu: false,
      expand: false,
    },
    {
      path: ROUTE_NAME._404,
      component: Trang404,
      isShowLeftMenu: false,
      expand: false,
    },
    {
      path: ROUTE_NAME._500,
      component: Trang500,
      isShowLeftMenu: false,
      expand: false,
    },
    {
      path: ROUTE_NAME.DANG_NHAP,
      name: ROUTE_NAME.DANG_NHAP,
      component: TrangDangNhap,
    },
    {
      path: ROUTE_NAME.QUAN_LY_DANH_MUC.NAME,
      name: ROUTE_NAME.QUAN_LY_DANH_MUC.NAME,
      menuName: MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.NAME,
      component: TrangRouter,
      props: true,
      icon: "menu-button-wide-fill",
      isShowLeftMenu: true,
      expand: false,
      // meta: {
      //   permissionName: PERMISSION_NAME.QUAN_TRI_HE_THONG
      // },
      children: [
        {
          path: ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.NAME,
          name: ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.NAME,
          menuName: MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.NAME,
          component: TrangDanhSachDonVi,
          meta: {
            permissionName: PERMISSION_NAME.DON_VI.QUAN_LY,
          },
        },
        {
          path: ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.TAO,
          name: ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.TAO,
          menuName: MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.TAO,
          component: TrangTaoDonVi,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.DON_VI.THEM,
          },
        },
        {
          path: ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.SUA,
          name: ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.SUA,
          menuName: MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.SUA,
          component: TrangSuaDonVi,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.DON_VI.SUA,
          },
        },
        {
          path: ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.XEM,
          name: ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.XEM,
          menuName: MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.DON_VI.XEM,
          component: TrangXemDonVi,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.DON_VI.XEM,
          },
        },
        {
          path: ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.NAME,
          name: ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.NAME,
          menuName: MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.NAME,
          component: TrangDanhSachHoSoCanBo,
          meta: {
            permissionName: PERMISSION_NAME.CAN_BO.QUAN_LY,
          },
        },
        {
          path: ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.TAO,
          name: ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.TAO,
          menuName: MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.TAO,
          component: TrangTaoHoSoCanBo,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.CAN_BO.THEM,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_NHAT_THONG_TIN_NGUOI_DUNG,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_NHAT_THONG_TIN_NGUOI_DUNG,
          menuName: MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.SUA,
          component: TrangSuaHoSoCanBo,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.CAN_BO.SUA,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.XEM_CHI_TIET_THONG_TIN_NGUOI_DUNG,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.XEM_CHI_TIET_THONG_TIN_NGUOI_DUNG,
          menuName: MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.SUA,
          component: TrangXemHoSoCanBo,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.CAN_BO.SUA,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.CHI_TIET_QUAN_LY_CAN_BO_NAME,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.CHI_TIET_QUAN_LY_CAN_BO_NAME,
          menuName:
            MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CHI_TIET_QUAN_LY_CAN_BO_NAME,
          component: TrangXemHoSoCanBoThuocDonVi,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.CAN_BO.XEM,
          },
        },
        {
          path: ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.SUA,
          name: ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.SUA,
          menuName: MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.SUA,
          component: TrangSuaHoSoCanBo,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.CAN_BO.SUA,
          },
        },
        {
          path: ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.XEM,
          name: ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.XEM,
          menuName: MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.XEM,
          component: TrangXemHoSoCanBo,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.CAN_BO.XEM,
          },
        },
        {
          path: ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.XEM_THUOC_DON_VI,
          name: ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.XEM_THUOC_DON_VI,
          menuName:
            MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.XEM_THUOC_DON_VI,
          component: TrangXemHoSoCanBoThuocDonVi,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.CAN_BO.XEM,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.NGUOI_DUNG,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.NGUOI_DUNG,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.NGUOI_DUNG,
          component: TrangQuanLyNguoiDung,
          meta: {
            permissionName: PERMISSION_NAME.NGUOI_DUNG.QUAN_LY,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.XEM_CHI_TIET_NGUOI_DUNG,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.XEM_CHI_TIET_NGUOI_DUNG,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.XEM_CHI_TIET_NGUOI_DUNG,
          component: TrangXemNguoiDung,
          meta: {
            permissionName: PERMISSION_NAME.NGUOI_DUNG.XEM,
          },
          isShowLeftMenu: false,
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_NHAT_NGUOI_DUNG,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_NHAT_NGUOI_DUNG,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_NHAT_NGUOI_DUNG,
          component: TrangCapNhatNguoiDung,
          meta: {
            permissionName: PERMISSION_NAME.NGUOI_DUNG.SUA,
          },
          isShowLeftMenu: false,
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.VAI_TRO,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.VAI_TRO,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.VAI_TRO,
          component: TrangDanhSachVaiTro,
          meta: {
            permissionName: PERMISSION_NAME.VAI_TRO.QUAN_LY,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.XEM_CHI_TIET_VAI_TRO,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.XEM_CHI_TIET_VAI_TRO,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.XEM_CHI_TIET_VAI_TRO,
          component: TrangXemVaiTro,
          meta: {
            permissionName: PERMISSION_NAME.VAI_TRO.XEM,
          },
          isShowLeftMenu: false,
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_NHAT_VAI_TRO,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_NHAT_VAI_TRO,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_NHAT_VAI_TRO,
          component: TrangCapNhatVaiTro,
          meta: {
            permissionName: PERMISSION_NAME.VAI_TRO.SUA,
          },
          isShowLeftMenu: false,
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.NAME,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.NAME,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.NAME,
          component: TrangDanhSachGroup,
          meta: {
            permissionName: PERMISSION_NAME.NHOM_NGUOI_DUNG.QUAN_LY,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.SUA,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.SUA,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.SUA,
          component: TrangCapNhatGroup,
          meta: {
            permissionName: PERMISSION_NAME.NHOM_NGUOI_DUNG.QUAN_LY,
          },
          isShowLeftMenu: false,
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.PERMISSION.NAME,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.PERMISSION.NAME,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.PERMISSION.NAME,
          component: TrangDanhSachQuyen,
          meta: {
            permissionName: PERMISSION_NAME.QUYEN.QUAN_LY,
          },
        },
        {
          //TODO: ÁPP
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.APP.NAME,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.APP.NAME,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.APP.NAME,
          component: TrangDanhSachApp,
          meta: {
            permissionName: PERMISSION_NAME.UNG_DUNG.QUAN_LY,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_DON_VI.NAME,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_DON_VI.NAME,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_DON_VI.NAME,
          component: TrangDanhSachCapDonVi,
          meta: {
            permissionName: PERMISSION_NAME.CAP_DON_VI.QUAN_LY,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.NHOM_CHUC_VU.NAME,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.NHOM_CHUC_VU.NAME,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.NHOM_CHUC_VU.NAME,
          component: TrangDanhSachNhomChucVu,
          meta: {
            permissionName: PERMISSION_NAME.NHOM_CHUC_VU.QUAN_LY,
          },
        },

        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.CHUC_VU.NAME,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.CHUC_VU.NAME,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CHUC_VU.NAME,
          component: TrangDanhSachChucVu,
          meta: {
            permissionName: PERMISSION_NAME.CHUC_VU.QUAN_LY,
          },
        },
        {
          path: ROUTE_NAME.QUAN_LY_DANH_MUC.TINH_THANH.XEM,
          name: ROUTE_NAME.QUAN_LY_DANH_MUC.TINH_THANH.XEM,
          menuName: MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.TINH_THANH.XEM,
          component: TrangDanhSachTinhThanhPho,
          isShowLeftMenu: true,
          meta: {
            permissionName: PERMISSION_NAME.TINH_THANH.QUAN_LY,
          },
        },
        // {
        //   path: ROUTE_NAME.QUAN_LY_DANH_MUC.THONG_BAO_TUY_CHINH.NAME,
        //   name: ROUTE_NAME.QUAN_LY_DANH_MUC.THONG_BAO_TUY_CHINH.NAME,
        //   menuName: MENU_ROUTE_NAME.QUAN_LY_DANH_MUC.THONG_BAO_TUY_CHINH.NAME,
        //   component: TrangDanhSachThongBao,
        // },
      ],
    },
    // {
    //   path: ROUTE_NAME.LICH_LAM_VIEC.NAME,
    //   name: ROUTE_NAME.LICH_LAM_VIEC.NAME,
    //   menuName: MENU_ROUTE_NAME.LICH_LAM_VIEC.NAME,
    //   component: TrangLichLamViec,
    //   icon: "user-clock",
    //   isShowLeftMenu: true,
    //   expand: false
    // },
    // {
    //   path: ROUTE_NAME.LICH_LAM_VIEC.TAO_LICH_LAM_VIEC,
    //   name: ROUTE_NAME.LICH_LAM_VIEC.TAO_LICH_LAM_VIEC,
    //   menuName: MENU_ROUTE_NAME.LICH_LAM_VIEC.NAME,
    //   component: TrangTaoLichLamViec,
    //   isShowLeftMenu: false,
    //   expand: false
    // },
    // {
    //   path: ROUTE_NAME.LICH_LAM_VIEC.DANH_SACH_LICH_LAM_VIEC,
    //   name: ROUTE_NAME.LICH_LAM_VIEC.DANH_SACH_LICH_LAM_VIEC,
    //   component: TrangTongHopLichLamViec,
    //   isShowLeftMenu: false,
    //   beforeEnter: (to, from, next) => {
    //     if (to.params.id) {
    //       next();
    //     } else {
    //       next({ name: ROUTE_NAME.NOT_FOUND });
    //     }
    //   }
    // },
    // {
    //   path: ROUTE_NAME.THONG_BAO.NAME,
    //   name: ROUTE_NAME.THONG_BAO.NAME,
    //   menuName: MENU_ROUTE_NAME.THONG_BAO.NAME,
    //   component: TrangThongBao,
    //   icon: "bell",
    //   isShowLeftMenu: true,
    //   expand: false
    // },
    // {
    //   path: ROUTE_NAME.QUAN_LY_THONG_BAO,
    //   name: ROUTE_NAME.QUAN_LY_THONG_BAO,
    //   menuName: MENU_ROUTE_NAME.QUAN_LY_THONG_BAO,
    //   component: TrangQuanLyThongBao,
    //   icon: "bell",
    //   isShowLeftMenu: false,
    //   expand: false
    // },
    // {
    //   path: ROUTE_NAME.THONG_BAO_CHO_DUYET,
    //   name: ROUTE_NAME.THONG_BAO_CHO_DUYET,
    //   menuName: MENU_ROUTE_NAME.THONG_BAO_CHO_DUYET,
    //   component: TrangThongBaoChoDuyet,
    //   icon: "bell",
    //   isShowLeftMenu: false,
    //   expand: false
    // },
    // {
    //   path: ROUTE_NAME.THONG_BAO.TAO_THONG_BAO,
    //   name: ROUTE_NAME.THONG_BAO.TAO_THONG_BAO,
    //   menuName: MENU_ROUTE_NAME.THONG_BAO.NAME,
    //   component: TrangTaoThongBao,
    //   isShowLeftMenu: false,
    //   expand: false
    // },
    // {
    //   path: ROUTE_NAME.THONG_BAO.CHI_TIET_THONG_BAO,
    //   name: ROUTE_NAME.THONG_BAO.CHI_TIET_THONG_BAO,
    //   component: TrangTaoThongBao,
    //   beforeEnter: (to, from, next) => {
    //     if (to.params.id) {
    //       next();
    //     } else {
    //       next({ name: ROUTE_NAME.TRANG_CHU });
    //     }
    //   }
    // },
    // {
    //   path: ROUTE_NAME.THONG_BAO.XEM_THONG_BAO,
    //   name: ROUTE_NAME.THONG_BAO.XEM_THONG_BAO,
    //   menuName: MENU_ROUTE_NAME.THONG_BAO.XEM_THONG_BAO,
    //   component: TrangXemThongBao
    // },
    // {
    //   path: ROUTE_NAME.THONG_BAO.DANH_SACH_THONG_BAO_THEO_DANH_MUC,
    //   name: ROUTE_NAME.THONG_BAO.DANH_SACH_THONG_BAO_THEO_DANH_MUC,
    //   component: TrangDanhSachThongBaoTheoDanhMuc,
    //   beforeEnter: (to, from, next) => {
    //     if (to.params.id) {
    //       next();
    //     } else {
    //       next({ name: ROUTE_NAME.TRANG_CHU });
    //     }
    //   }
    // },
    {
      path: ROUTE_NAME.QUAN_TRI_HE_THONG.NAME,
      name: ROUTE_NAME.QUAN_TRI_HE_THONG.NAME,
      menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.NAME,
      component: TrangRouter,
      props: true,
      //icon: "gear",
      faIcon: "user-cog",
      isShowLeftMenu: true,
      expand: false,
      // meta: {
      //   permissionName: PERMISSION_NAME.QUAN_TRI_HE_THONG
      // },
      children: [
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.XEM_CHI_TIET_GROUP,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.XEM_CHI_TIET_GROUP,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.XEM_CHI_TIET_GROUP,
          component: TrangXemGroup,
          isShowLeftMenu: false,
        },
        // {
        //   path: ROUTE_NAME.QUAN_TRI_HE_THONG.CHUC_VU.NAME,
        //   name: ROUTE_NAME.QUAN_TRI_HE_THONG.CHUC_VU.NAME,
        //   menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CHUC_VU.NAME,
        //   component: TrangDanhSachChucVu,
        //   meta: {
        //     permissionName: PERMISSION_NAME.QUAN_TRI_HE_THONG
        //   }
        // },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.CHUC_VU.TAO,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.CHUC_VU.TAO,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CHUC_VU.TAO,
          component: TrangTaoChucVu,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.CHUC_VU.THEM,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.CHUC_VU.SUA,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.CHUC_VU.SUA,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CHUC_VU.SUA,
          component: TrangSuaChucVu,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.CHUC_VU.SUA,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.CHUC_VU.XEM,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.CHUC_VU.XEM,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CHUC_VU.XEM,
          component: TrangXemChucVu,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.CHUC_VU.XEM,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.NHOM_CHUC_VU.TAO,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.NHOM_CHUC_VU.TAO,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.NHOM_CHUC_VU.TAO,
          component: TrangTaoNhomChucVu,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.NHOM_CHUC_VU.THEM,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.NHOM_CHUC_VU.SUA,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.NHOM_CHUC_VU.SUA,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.NHOM_CHUC_VU.SUA,
          component: TrangSuaNhomChucVu,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.NHOM_CHUC_VU.SUA,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.NHOM_CHUC_VU.XEM,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.NHOM_CHUC_VU.XEM,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.NHOM_CHUC_VU.XEM,
          component: TrangXemNhomChucVu,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.NHOM_CHUC_VU.XEM,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_DON_VI.TAO,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_DON_VI.TAO,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_DON_VI.TAO,
          component: TrangTaoCapDonVi,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.CAP_DON_VI.THEM,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_DON_VI.SUA,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_DON_VI.SUA,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_DON_VI.SUA,
          component: TrangSuaCapDonVi,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.CAP_DON_VI.SUA,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_DON_VI.XEM,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_DON_VI.XEM,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_DON_VI.XEM,
          component: TrangXemCapDonVi,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.NHOM_CHUC_VU.XEM,
          },
        },

        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.DM_HE_THONG.TAO,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.DM_HE_THONG.TAO,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.DM_HE_THONG.TAO,
          component: TrangTaoDanhMucHeThong,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.QUAN_TRI_HE_THONG,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.DM_HE_THONG.SUA,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.DM_HE_THONG.SUA,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.DM_HE_THONG.SUA,
          component: TrangSuaDanhMucHeThong,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.QUAN_TRI_HE_THONG,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.DM_HE_THONG.XEM,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.DM_HE_THONG.XEM,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.DM_HE_THONG.XEM,
          component: TrangXemDanhMucHeThong,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.QUAN_TRI_HE_THONG,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.DM_MENU_HE_THONG.TAO,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.DM_MENU_HE_THONG.TAO,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.DM_MENU_HE_THONG.TAO,
          component: TrangTaoDanhMucMenuHeThong,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.QUAN_TRI_HE_THONG,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.DM_MENU_HE_THONG.SUA,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.DM_MENU_HE_THONG.SUA,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.DM_MENU_HE_THONG.SUA,
          component: TrangSuaDanhMucMenuHeThong,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.QUAN_TRI_HE_THONG,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.DM_MENU_HE_THONG.XEM,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.DM_MENU_HE_THONG.XEM,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.DM_MENU_HE_THONG.XEM,
          component: TrangXemDanhMucMenuHeThong,
          isShowLeftMenu: false,
          meta: {
            permissionName: PERMISSION_NAME.QUAN_TRI_HE_THONG,
          },
        },

        // {
        //   path: ROUTE_NAME.QUAN_TRI_HE_THONG.THONG_BAO.NAME,
        //   name: ROUTE_NAME.QUAN_TRI_HE_THONG.THONG_BAO.NAME,
        //   menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.THONG_BAO.NAME,
        //   component: TrangQuanTriThongBao,
        //   isShowLeftMenu: true
        // },

        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.IMPORT.NAME,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.IMPORT.NAME,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.IMPORT.NAME,
          component: TrangImport,
          meta: {
            permissionName: PERMISSION_NAME.IMPORT.IMPORT_DU_LIEU,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_THONG_TIN_NGUOI_DUNG,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_THONG_TIN_NGUOI_DUNG,
          menuName:
            MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_THONG_TIN_NGUOI_DUNG,
          component: TrangQuanLyThongTinNguoiDung,
          meta: {
            permissionName: PERMISSION_NAME.NGUOI_DUNG.QUAN_LY,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.LOG.NAME,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.LOG.NAME,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.LOG.NAME,
          component: TrangDanhSachLog,
          isShowLeftMenu: true,
          meta: {
            permissionName: PERMISSION_NAME.LOG.QUAN_LY,
          },
        },
      ],
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = [ROUTE_NAME.DANG_NHAP];
  const authRequired = !publicPages.includes(to.path);

  const token = to.query.token;
  if (token) {
    HTTP.defaults.headers["Authorization"] = `Bearer ${token}`;
    HTTP.defaults.headers["Access-Control-Allow-Origin"] = "*";
    setValueToStorageByKey("accessToken", token);
    setValueToStorageByKey("isLogin", true);
    store.dispatch("common/setIsLogin", true);
    store.dispatch("common/setIsIframe", true);
    await store.dispatch("common/setPermission");
  }
  const appId = to.query.appId;
  if (appId) {
    store.dispatch("common/setAppId", appId);
  }

  const loggedIn = getValueFromStorageByKey("isLogin");

  const hasPer = hasPermissionUser(to && to.meta && to.meta.permissionName);

  if (authRequired && !loggedIn && !token) {
    store.dispatch("common/setIsLogin", false);
    return next(ROUTE_NAME.DANG_NHAP);
  } else if (!authRequired && loggedIn && !token) {
    return next(ROUTE_NAME.TRANG_CHU);
  } else if (!hasPer && !token) {
    return next(ROUTE_NAME.TRANG_CHU);
  }
  next();
});

export default router;
